export const TIPOS_UNIDAD_REQUEST = "TIPOS_UNIDAD_REQUEST";
export const TIPOS_UNIDAD_OK = "TIPOS_UNIDAD_OK";
export const TIPOS_UNIDAD_ERROR = "TIPOS_UNIDAD_ERROR";
